export const handleRequestLanguage = (args) => {
  const { site, language } = args.body || {};
  let updatedPayload = { ...args };

  if (
    site === 'Intermediary' &&
    language?.toLowerCase() === 'en-us' &&
    (args.url.includes('funds') || args.url.includes('library'))
  ) {
    updatedPayload = {
      ...args,
      body: {
        ...args.body,
        language: 'en-lu',
      },
    };
  }

  if (language?.toLowerCase() === 'en-nz') {
    updatedPayload = {
      ...args,
      body: {
        ...args.body,
        language: 'en-au',
      },
    };
  }

  return updatedPayload;
};

export const requestHandler = async (baseQueryCB, args, api) => {
  const updatedPayload = handleRequestLanguage(args);

  const result = await baseQueryCB(updatedPayload, api);
  return result;
};
